import React from 'react'
import NavBar from './NavBar'
import './Error.css';

const Error = () => {
  return (
    <div className="Page">
      <div className='content'>
        <NavBar/>
        <div className='errorMessage'>That page couldn't be found.</div>
        <div className='subtitle'> <a href="/" className='green'>Return to the Homepage →</a></div>
        </div>
    </div>
  )
}

export default Error